<template>
  <div class="form-traffic-electronic-mail">
    <iframe id="iframeGuarantee" class="iframe-guarantee" :src="iframeUrl" frameborder="0"></iframe>
  </div>
</template>
<script>
import trafficUtils from '@/common/tender/traffic/utils'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'BearTrafficElectronicMail',
  data () {
    return {
      iframeUrl: 'about:blank'
    }
  },
  computed: {
    ...mapState(['actions', 'form', 'baseInfo'])
  },
  watch: {
    actions (val, oldVal) {
      if (val.length && !oldVal.length) {
        this.initIframeUrl()
      }
    }
  },
  mounted () {
    this.setVm(this)
    window.GetSdata = () => {
      const { form, baseInfo } = this
      return trafficUtils.buildGuaranteeData(form, baseInfo)
    }
  },
  methods: {
    ...mapMutations('electronicMail', ['setVm']),
    ...mapActions('electronicMail', ['requestHost']),
    initIframeUrl () {
      this.requestHost().then(host => {
        this.iframeUrl = `/WEB_BH/pages/JTDZBH.html?notTender=false&reportServer=${host}&foId=202211181604111`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.form-traffic-electronic-mail {
  width: 900px;
  margin: 0 auto;
  .iframe-guarantee {
    width: 100%;
  }
}
</style>